// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__3O8Jr","avatar":"Item_avatar__1pls1","man":"Item_man__3ZkAQ","position":"Item_position__oHDA-"};